import {create} from "zustand";

export const useSearchInputStore = create((set) => ({
    searchQuery: '',
    setSearchQuery: (value) => set({ searchQuery: value }),
    initSearchQuery: () => set({ searchQuery: '' }),
}));
